import { render } from "./DefaultBanner.vue?vue&type=template&id=2c677208&scoped=true"
import script from "./DefaultBanner.vue?vue&type=script&lang=js"
export * from "./DefaultBanner.vue?vue&type=script&lang=js"

import "./DefaultBanner.vue?vue&type=style&index=0&id=2c677208&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c677208"]])

export default __exports__